import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { VEHICLE_REMOTE_COMMAND_FIELDS } from './remoteCommandFields';

export const CHECK_VEHICLE_REMOTE_COMMAND_STATUS_MUTATION = `
	mutation checkVehicleRemoteCommandStatus($id: ID!) {
		RemoteCommand: checkVehicleRemoteCommandStatus(id: $id) {
			${VEHICLE_REMOTE_COMMAND_FIELDS}
		}
	}
`;

/**
 * Asks the backend to check an active command's status with the provider
 * (general API, Cognito). It returns the stored row (updated when the status
 * changed); the backend calls the provider at most every 4 s per command.
 * Null when the command does not exist.
 */
export const checkVehicleRemoteCommandStatus = async (id) => {
	const res = await clientMutation(CHECK_VEHICLE_REMOTE_COMMAND_STATUS_MUTATION, { id: String(id) }, endpoints.GRAPHQL_GENERAL_V2);
	return res?.RemoteCommand ?? null;
};
